// custom imports
import { VendState } from ".";
import { createLocationSlice } from "./location";
import { createMachineSlice, resetMachineLoadState } from "./machine";
import { createIntegrationSlice, resetIntegrationLoadState } from "./integration";
import { createTelemetrySlice } from "./telemetry";
import { clearTaskLoadInFlight, createTaskSlice } from "./task";
import { createInsightsSlice } from "./insights";
import { createOrgMembersSlice } from "./orgMembers";
import { createInventorySlice, resetInventoryLoadState } from "./inventory";
import { resetVendCaches } from "../api/cache";
import { resetLocationLoadState } from "./location";

// third party
import { create } from "zustand";
import { baseState } from "../../state/store";


export const useVendStore = create<VendState>((set, get, store) => {
  return {
    ...baseState<VendState>(set, get),
    ...createMachineSlice(set, get, store),
    ...createLocationSlice(set, get, store),
    ...createIntegrationSlice(set, get, store),
    ...createTelemetrySlice(set, get, store),
    ...createTaskSlice(set, get, store),
    ...createInsightsSlice(set, get, store),
    ...createOrgMembersSlice(set, get, store),
    ...createInventorySlice(set, get, store),
    configTab: "integrations",
    setConfigTab: (configTab) => set({ configTab } as VendState),
    reset: () => {
      resetVendCaches();
      clearTaskLoadInFlight();
      resetMachineLoadState();
      resetIntegrationLoadState();
      resetLocationLoadState();
      resetInventoryLoadState();
      set(() => ({
        loading: { on: false },
        selected: [],
        status: undefined,
        machines: [],
        availableMachines: [],
        machinesHydrated: false,
        machinesLoading: false,
        machinesError: null,
        machinesFetchedAt: null,
        locations: [],
        addresses: [],
        locationsHydrated: false,
        locationsLoading: false,
        locationsError: null,
        locationsFetchedAt: null,
        tasks: [],
        tasksHydrated: false,
        tasksLoading: false,
        tasksError: null,
        tasksFetchedAt: null,
        taskContextKey: null,
        taskScopes: {},
        operators: [],
        operatorsHydrated: false,
        operatorsLoading: false,
        operatorsError: null,
        organizationMembers: [],
        organizationMembersLoading: false,
        organizationMembersError: null,
        organizationMembersFetchedAt: null,
        productsById: {},
        productIds: [],
        productsHydrated: false,
        productsLoading: false,
        productsFetchedAt: null,
        inventoryVans: [],
        inventoryVansLoading: false,
        inventoryVansFetchedAt: null,
        inventoriesById: {},
        inventoryIds: [],
        inventoryItemsById: {},
        inventoryItemIdsByInventoryId: {},
        inventoriesHydrated: false,
        inventoriesLoading: false,
        inventoriesFetchedAt: null,
        machineInventoryItemsById: {},
        machineInventoryItemIdsByMachineId: {},
        machineInventoryLoadingByMachineId: {},
        machineInventoryFetchedAtByMachineId: {},
        inventoryMovementsById: {},
        machineInventoryMovementIdsByItemId: {},
        machineInventoryMovementsLoadingByItemId: {},
        machineInventoryMovementsFetchedAtByItemId: {},
        taskFilters: { statuses: ["unassigned", "pending"], type: "all", query: "" },
        taskFiltersByKey: {},
        configTab: "integrations",
        integrationConfig: {
          telemetryProviders: [],
          webhooksEnabled: false,
          webhookUrl: "",
          notificationsEmail: "",
        },
        integrations: [],
        integrationsHydrated: false,
        machineTelemetry: {},
        insightsRange: "today",
      }));
    },
  };
});
